/**
 * QFAA client-page crash reporter.
 *
 * Forwards uncaught frontend errors to the `report_client_error` Cloud Function,
 * which routes them to the DEV Slack channel only (operators are never pinged
 * with client-page errors).
 *
 * Uses a raw fetch (not the axios instance) so it has no dependency on app state
 * during a crash, and `keepalive` so the report survives a navigation/unload.
 * Throttled and never throws.
 */
import { FIREBASE_FUNCTIONS_URL } from '../config/environment';

let _lastSentAt = 0;

export function reportClientError(payload = {}) {
  try {
    const now = Date.now();
    if (now - _lastSentAt < 3000) return; // throttle bursts (and avoid loops)
    _lastSentAt = now;
    fetch(`${FIREBASE_FUNCTIONS_URL}/report_client_error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        url: payload.url || (typeof window !== 'undefined' ? window.location.href : ''),
        userAgent: payload.userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    // error reporting must never throw
  }
}
